/// <amd-module name="Build/Admin/Common/Actions/NotificationActions" />
import { Action } from "VSS/Reflux/Action";

import { INotification } from "Build/Admin/Common/Stores/NotificationStore";

export class NotificationActions {
    public addNotification = new Action<INotification>();
    public dismissNotification = new Action<INotification>();
    public clearNotifications = new Action<void>();
}
